(() => {
  const ROOMS = ['Wohnzimmer', 'Schlafzimmer', 'Küche', 'Flur', 'Kinderzimmer', 'Möbel', 'Outdoor', 'Anderes'];
  const TAGS = [
    ['wohnzimmer', 'Wohnzimmer'], ['kalkfarbe', 'Kalkfarbe'], ['moebel', 'Möbel'],
    ['naturtoene', 'Naturtöne'], ['mutzurfarbe', 'MutZurFarbe'], ['vorhernachher', 'VorherNachher'],
    ['kreidefarbe', 'Kreidefarbe'], ['kueche', 'Küche'], ['schlafzimmer', 'Schlafzimmer'],
    ['outdoor', 'Outdoor'], ['pureandoriginal', 'PureAndOriginal'], ['farrowandball', 'FarrowAndBall'],
    ['kalkundkreide', 'KalkundKreide'], ['esszimmer', 'Esszimmer'], ['flur', 'Flur'],
    ['diyandupcycling', 'DIYAndUpcycling']
  ];

  function init(root) {
    if (root.dataset.mediaPatch) return;
    root.dataset.mediaPatch = 'true';
    const feed = root.querySelector('[data-feed]');
    const commentsDialog = root.querySelector('[data-comments-dialog]');
    const profileDialog = root.querySelector('[data-profile-dialog]');
    const rewardsDialog = root.querySelector('[data-rewards-dialog]');
    const redeemDialog = root.querySelector('[data-redeem-dialog]');
    const loginGateDialog = root.querySelector('[data-login-gate-dialog]');
    const redemptionForm = root.querySelector('#kk-community-redemption');
    const apiBase = String(root.dataset.apiEndpoint || '').replace(/\/$/, '');
    let editingArticle = null;
    let modalArticle = null;
    let editingComment = null;
    let returnToProfileAfterComments = false;
    let commentCatalog = new Map();
    let commentSignature = '';
    let commentRefreshTimer = 0;
    let redemptionSubmitting = false;
    let returnToRewardsAfterRedeem = false;
    const commentOverrides = new Map();
    const wiredComparisonDots = new WeakSet();

    function openLoginGate(event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      if (loginGateDialog && !loginGateDialog.open) {
        loginGateDialog.showModal();
        loginGateDialog.focus({ preventScroll: true });
      }
    }

    if (root.dataset.loggedIn !== 'true' && feed && loginGateDialog) {
      const gatedSelector = '[data-like],[data-focus-comment],[data-share],[data-save],[data-follow],[data-comment-input],[data-comment-form] button';
      feed.addEventListener('click', event => {
        if (event.target.closest(gatedSelector)) openLoginGate(event);
      }, true);
      feed.addEventListener('dblclick', event => {
        if (event.target.closest('.kkc-post__media')) openLoginGate(event);
      }, true);
      loginGateDialog.querySelector('[data-close-login-gate]')?.addEventListener('click', () => loginGateDialog.close());
      loginGateDialog.addEventListener('click', event => {
        if (event.target === loginGateDialog) loginGateDialog.close();
      });
    }

    function wireFeedProfileNames(scope = feed) {
      scope?.querySelectorAll('.kkc-post[data-author]').forEach(article => {
        const author = String(article.dataset.author || '').replace(/^@/, '').trim();
        if (!author) return;
        const avatar = article.querySelector('.kkc-post__header .kkc-avatar');
        const name = article.querySelector('.kkc-post__identity strong');
        [avatar, name].forEach(trigger => {
          if (!trigger) return;
          trigger.dataset.profileOpen = author;
          trigger.setAttribute('role', 'button');
          trigger.tabIndex = 0;
        });
      });
    }

    wireFeedProfileNames();
    if (feed) {
      new MutationObserver(() => wireFeedProfileNames()).observe(feed, { childList: true, subtree: true });
      feed.addEventListener('keydown', event => {
        if (!event.target.matches('[data-profile-open]') || !['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        event.target.click();
      });
    }

    const editor = document.createElement('dialog');
    editor.className = 'kkc-edit-dialog';
    editor.innerHTML = `
      <form class="kkc-edit-form" method="dialog">
        <div class="kkc-edit-head"><div class="kkc-edit-title-wrap"><p class="kkc-edit-kicker">Dein Community-Beitrag</p><h2>Beitrag bearbeiten</h2></div><button class="kkc-edit-close" type="button" aria-label="Schließen"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 4l12 12M16 4 4 16"/></svg></button></div>
        <div class="kkc-edit-content">
          <label class="kkc-edit-field">Bereich<span class="kkc-edit-select-wrap"><select name="room" required></select></span></label>
          <label class="kkc-edit-field">Deine Farbgeschichte<textarea name="caption" maxlength="700" required></textarea></label>
          <div class="kkc-edit-field"><span>Hashtags · bis zu 5</span><div class="kkc-edit-tags"></div></div>
          <p class="kkc-edit-note">Bilder, Video und die verknüpfte Farbe bleiben unverändert.</p>
          <p class="kkc-edit-status" role="status"></p>
        </div>
        <div class="kkc-edit-actions"><button type="button" data-edit-cancel>Abbrechen</button><button type="submit">Änderungen speichern</button></div>
      </form>`;
    root.append(editor);
    const editForm = editor.querySelector('form');
    const roomSelect = editForm.elements.room;
    const captionField = editForm.elements.caption;
    const tagsHolder = editor.querySelector('.kkc-edit-tags');
    const status = editor.querySelector('.kkc-edit-status');

    const commentEditor = document.createElement('dialog');
    commentEditor.className = 'kkc-comment-edit-dialog';
    commentEditor.innerHTML = `
      <form class="kkc-comment-edit-form">
        <div class="kkc-edit-head"><div class="kkc-edit-title-wrap"><p class="kkc-edit-kicker">Dein Kommentar</p><h2>Kommentar bearbeiten</h2></div><button class="kkc-edit-close" type="button" data-comment-edit-close aria-label="Schließen"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 4l12 12M16 4 4 16"/></svg></button></div>
        <div class="kkc-edit-content">
          <label class="kkc-edit-field">Kommentar<textarea name="comment" minlength="8" maxlength="280" required></textarea></label>
          <p class="kkc-edit-note">Deine ursprünglichen Kalkpunkte bleiben dabei unverändert.</p>
          <p class="kkc-edit-status" role="status" data-comment-edit-status></p>
        </div>
        <div class="kkc-edit-actions"><button type="button" data-comment-edit-close>Abbrechen</button><button type="submit">Änderungen speichern</button></div>
      </form>`;
    root.append(commentEditor);
    const commentEditForm = commentEditor.querySelector('form');
    const commentEditField = commentEditForm.elements.comment;
    const commentEditStatus = commentEditor.querySelector('[data-comment-edit-status]');
    roomSelect.replaceChildren(...ROOMS.map(room => new Option(room, room)));
    tagsHolder.replaceChildren(...TAGS.map(([value, label]) => {
      const wrapper = document.createElement('label');
      wrapper.className = 'kkc-edit-tag';
      const input = document.createElement('input');
      input.type = 'checkbox'; input.name = 'hashtags'; input.value = value;
      const text = document.createElement('span');
      text.textContent = `#${label}`;
      wrapper.append(input, text);
      return wrapper;
    }));

    function currentMode(mode = '') {
      root.dataset.accountGallery = mode;
      if (mode === 'own' || mode === 'saved') {
        setTimeout(() => activateGalleryComparisons(true));
      }
    }

    function comparisonSource(media, index) {
      return media.querySelector(`.kkc-compare-toggle [data-media-go="${index}"]`);
    }

    function syncGalleryComparison(media) {
      const active = String(media.dataset.activeMedia || '0');
      media.querySelectorAll('.kkc-gallery-compare-toggle button').forEach(button => {
        const selected = button.dataset.galleryCompareGo === active;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', String(selected));
      });
      media.querySelectorAll('.kkc-comparison-dots button').forEach(button => {
        const selected = button.dataset.comparisonDotGo === active;
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-current', selected ? 'true' : 'false');
      });
    }

    function showGalleryComparison(media, index) {
      const source = comparisonSource(media, index);
      if (!source) return;
      source.click();
      media.dataset.activeMedia = String(index);
      syncGalleryComparison(media);
    }

    function ensureComparisonDots(media) {
      const sourceToggle = media.querySelector('.kkc-compare-toggle');
      if (!sourceToggle) return;
      let dots = media.querySelector('.kkc-comparison-dots');
      if (!dots) {
        dots = document.createElement('div');
        dots.className = 'kkc-media-dots kkc-comparison-dots';
        dots.setAttribute('aria-label', 'Bild auswählen');
        ['Vorher', 'Nachher'].forEach((label, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.comparisonDotGo = String(index);
          button.setAttribute('aria-label', `${label}-Bild anzeigen`);
          dots.append(button);
        });
        media.append(dots);
      }
      dots.querySelectorAll('button').forEach(button => {
        if (wiredComparisonDots.has(button)) return;
        wiredComparisonDots.add(button);
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          showGalleryComparison(media, Number(button.dataset.comparisonDotGo || 0));
        });
      });
      sourceToggle.querySelectorAll('[data-media-go]').forEach(button => {
        if (wiredComparisonDots.has(button)) return;
        wiredComparisonDots.add(button);
        button.addEventListener('click', () => requestAnimationFrame(() => syncGalleryComparison(media)));
      });
      syncGalleryComparison(media);
    }

    function ensureGalleryComparison(media) {
      if (!media.querySelector('.kkc-compare-toggle')) return;
      delete media.dataset.mediaLabel;
      let toggle = media.querySelector('.kkc-gallery-compare-toggle');
      if (!toggle) {
        toggle = document.createElement('div');
        toggle.className = 'kkc-gallery-compare-toggle';
        toggle.setAttribute('aria-label', 'Vorher- und Nachher-Bild wählen');
        ['Vorher', 'Nachher'].forEach((label, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.galleryCompareGo = String(index);
          button.textContent = label;
          button.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            showGalleryComparison(media, index);
          });
          toggle.append(button);
        });
        media.append(toggle);
      }
      syncGalleryComparison(media);
    }

    function activateGalleryComparisons(forceAfter = false) {
      feed?.querySelectorAll('.kkc-post__media:has(.kkc-compare-toggle)').forEach(media => {
        ensureGalleryComparison(media);
        if (forceAfter) showGalleryComparison(media, 1);
      });
    }

    function decorate() {
      feed?.querySelectorAll('.kkc-media-arrow').forEach(arrow => {
        if (arrow.dataset.cleanArrow === 'true') return;
        const previous = arrow.classList.contains('kkc-media-arrow--prev') || arrow.dataset.mediaDirection === 'prev';
        arrow.dataset.cleanArrow = 'true';
        arrow.replaceChildren();
        arrow.insertAdjacentHTML('afterbegin', previous
          ? '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m12.5 4.5-5.5 5.5 5.5 5.5"/></svg>'
          : '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m7.5 4.5 5.5 5.5-5.5 5.5"/></svg>');
        arrow.setAttribute('aria-label', previous ? 'Vorheriges Bild' : 'Nächstes Bild');
      });
      feed?.querySelectorAll('.kkc-post__media').forEach(media => {
        const count = media.querySelectorAll('.kkc-media-slide').length;
        if (media.querySelector('.kkc-compare-toggle')) {
          ensureComparisonDots(media);
          ensureGalleryComparison(media);
          if (media.dataset.comparisonDefaulted !== 'true') {
            media.dataset.comparisonDefaulted = 'true';
            showGalleryComparison(media, 1);
          }
        }
        else if (count > 1) media.dataset.mediaLabel = `${count} Medien`;
        else delete media.dataset.mediaLabel;

        const article = media.closest('.kkc-post');
        if (article) ensureHashtags(article);
        const deleteButton = media.querySelector('.kkc-own-post-delete[data-delete-post]');
        if (!article || !deleteButton || media.querySelector('.kkc-own-post-edit')) return;
        const editButton = document.createElement('button');
        editButton.type = 'button';
        editButton.className = 'kkc-own-post-edit';
        editButton.setAttribute('aria-label', 'Eigenen Beitrag bearbeiten');
        editButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m4 16-.8 4.8L8 20l10.7-10.7a2.1 2.1 0 0 0-3-3Z"/><path d="m14.8 7.2 2 2"/></svg>';
        editButton.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          openEditor(article);
        });
        media.append(editButton);
      });
    }

    function ensureHashtags(article) {
      const body = article.querySelector('.kkc-post__body');
      if (!body) return;
      const values = hashtagValues(article);
      if (!values.length) return;
      article.style.setProperty('--kkc-post-accent', articleAccent(article));
      let holder = body.querySelector('.kkc-post__tags');
      if (!holder) {
        holder = document.createElement('div');
        holder.className = 'kkc-post__tags';
        const caption = body.querySelector('.kkc-post__caption');
        caption ? caption.insertAdjacentElement('afterend', holder) : body.append(holder);
      }
      const signature = values.join('|');
      if (holder.dataset.tagsSignature === signature) return;
      holder.dataset.tagsSignature = signature;
      holder.replaceChildren(...values.map(value => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.category = value;
        button.textContent = `#${TAGS.find(tag => tag[0] === value)?.[1] || value}`;
        return button;
      }));
    }

    function hashtagValues(article) {
      const raw = String(article.dataset.categories || '').trim();
      let values = [];
      if (raw) {
        try {
          const parsed = JSON.parse(raw);
          values = Array.isArray(parsed) ? parsed : [];
        } catch (_) {
          values = raw.split(/[\s,]+/);
        }
      }
      values = values.map(value => String(value).trim().replace(/^#/, '').toLowerCase()).filter(Boolean);
      article.querySelectorAll('.kkc-post__tags [data-category]').forEach(node => {
        const value = String(node.dataset.category || '').trim().replace(/^#/, '').toLowerCase();
        if (value) values.push(value);
      });
      return [...new Set(values)].slice(0, 5);
    }

    function articleAccent(article) {
      const avatar = article.querySelector('.kkc-avatar');
      const avatarAccent = avatar ? getComputedStyle(avatar).getPropertyValue('--member-accent').trim() : '';
      const rootAccent = getComputedStyle(root).getPropertyValue('--kkc-profile-accent').trim();
      return avatarAccent || rootAccent || '#71805c';
    }

    function syncModalHashtags(article) {
      if (!article || !commentsDialog?.open) return;
      const caption = commentsDialog.querySelector('[data-comments-post] .kkc-post__caption');
      if (!caption) return;
      const values = hashtagValues(article);
      if (!values.length) return;
      const signature = values.join('|');
      const previous = caption.querySelector('.kkc-comments-dialog__hashtags');
      if (previous?.dataset.tagsSignature === signature) return;
      previous?.remove();
      const holder = document.createElement('span');
      holder.className = 'kkc-comments-dialog__hashtags';
      holder.dataset.tagsSignature = signature;
      holder.style.setProperty('--kkc-post-accent', articleAccent(article));
      holder.append(...values.map(value => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.category = value;
        button.textContent = `#${TAGS.find(tag => tag[0] === value)?.[1] || value}`;
        return button;
      }));
      caption.append(holder);
    }

    function openEditor(article) {
      editingArticle = article;
      status.textContent = '';
      const location = article.querySelector('[data-template-location]')?.textContent || '';
      const room = location.split('·')[0].trim();
      roomSelect.value = ROOMS.includes(room) ? room : 'Anderes';
      captionField.value = article.querySelector('[data-template-caption]')?.textContent.trim() || '';
      const selected = new Set(String(article.dataset.categories || '').split(/\s+/).filter(Boolean));
      tagsHolder.querySelectorAll('input').forEach(input => { input.checked = selected.has(input.value); });
      editor.showModal();
      requestAnimationFrame(() => captionField.focus());
    }

    async function api(path, options = {}) {
      if (!apiBase) throw new Error('Die Community-Verbindung ist nicht verfügbar.');
      const response = await fetch(`${apiBase}${path}`, {
        ...options,
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', ...(options.headers || {}) }
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload.error || 'Änderung konnte nicht gespeichert werden.');
      return payload;
    }

    function showPatchToast(message) {
      const toast = root.querySelector('[data-toast]');
      if (!toast) return;
      clearTimeout(Number(toast.dataset.patchTimer || 0));
      toast.textContent = message;
      toast.hidden = false;
      const timer = setTimeout(() => { toast.hidden = true; }, 4200);
      toast.dataset.patchTimer = String(timer);
    }

    async function confirmCommunityRedemption() {
      if (!redemptionForm || !redeemDialog || redemptionSubmitting) return;
      if (!redemptionForm.reportValidity()) return;
      const reward = redeemDialog.dataset.redemptionReward || redeemDialog.querySelector('[data-redeem-title]')?.textContent?.trim() || '';
      const cost = Number(redeemDialog.dataset.redemptionCost || String(redeemDialog.querySelector('[data-redeem-cost]')?.textContent || '').replace(/\D/g, ''));
      const requestId = redeemDialog.dataset.redemptionRequestId || (typeof window.crypto?.randomUUID === 'function' ? window.crypto.randomUUID() : `request-${Date.now()}`);
      const submit = redemptionForm.querySelector('[data-confirm-redeem]');
      redemptionSubmitting = true;
      submit.disabled = true;
      submit.textContent = 'Wird sicher reserviert …';
      try {
        const result = await api('/loyalty/redeem', { method: 'POST', body: JSON.stringify({ reward, requestId }) });
        redemptionForm.querySelector('[data-community-redemption-reward]').value = reward;
        redemptionForm.querySelector('[data-community-redemption-points]').value = String(cost);
        redemptionForm.querySelector('[data-community-redemption-id]').value = result.redemptionId || '';
        redemptionForm.querySelector('[data-community-redemption-balance]').value = String(result.balance ?? '');
        redemptionForm.dataset.reserved = 'true';
        try { window.sessionStorage.setItem('kkc-redemption-success', 'true'); } catch (_) {}
        redemptionForm.requestSubmit();
      } catch (error) {
        redemptionSubmitting = false;
        delete redemptionForm.dataset.reserved;
        submit.disabled = false;
        submit.textContent = 'Einlösung bestätigen →';
        showPatchToast(error.message);
      }
    }

    if (redemptionForm && redeemDialog) {
      root.addEventListener('click', event => {
        const rewardButton = event.target.closest('[data-redeem-reward]');
        if (rewardButton) {
          redemptionForm.reset();
          delete redemptionForm.dataset.reserved;
          redemptionSubmitting = false;
          returnToRewardsAfterRedeem = true;
          redeemDialog.dataset.redemptionReward = rewardButton.dataset.redeemReward || '';
          redeemDialog.dataset.redemptionCost = rewardButton.dataset.redeemCost || '0';
          redeemDialog.dataset.redemptionRequestId = typeof window.crypto?.randomUUID === 'function' ? window.crypto.randomUUID() : `request-${Date.now()}`;
          return;
        }
        if (!event.target.closest('[data-confirm-redeem]')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        confirmCommunityRedemption();
      }, true);
      redemptionForm.addEventListener('submit', event => {
        if (redemptionForm.dataset.reserved === 'true') return;
        event.preventDefault();
        event.stopImmediatePropagation();
        confirmCommunityRedemption();
      }, true);
      redeemDialog.addEventListener('close', () => {
        if (!redemptionSubmitting && returnToRewardsAfterRedeem) {
          returnToRewardsAfterRedeem = false;
          setTimeout(() => { if (!rewardsDialog?.open) rewardsDialog?.showModal(); }, 40);
        }
      });
      try {
        const succeeded = new URL(window.location.href).searchParams.get('contact_posted') === 'true' || window.sessionStorage.getItem('kkc-redemption-success') === 'true';
        if (succeeded) {
          window.sessionStorage.removeItem('kkc-redemption-success');
          setTimeout(() => showPatchToast('Deine Prämienanfrage ist eingegangen. Wir melden uns in Kürze bei dir.'), 80);
        }
      } catch (_) {}
    }

    function commentTextNode(row) {
      const paragraph = row.querySelector('p');
      return [...(paragraph?.childNodes || [])].find(node => node.nodeType === Node.TEXT_NODE) || null;
    }

    function commentRowData(row) {
      const author = normalizeAuthor(row.querySelector('.kkc-comments-profile-name')?.textContent);
      const textNode = commentTextNode(row);
      return { author, text: String(textNode?.textContent || '').trim(), textNode };
    }

    function replaceCommentEverywhere(comment, previousText, nextText) {
      const author = normalizeAuthor(comment.author);
      commentsDialog?.querySelectorAll('.kkc-dialog-comment').forEach(row => {
        const current = commentRowData(row);
        if (current.author === author && current.text === previousText && current.textNode) current.textNode.textContent = ` ${nextText}`;
      });
      modalArticle?.querySelectorAll('[data-comments] .kkc-comment').forEach(line => {
        const lineAuthor = normalizeAuthor(line.querySelector('strong')?.textContent);
        const textNode = [...line.childNodes].find(node => node.nodeType === Node.TEXT_NODE);
        if (lineAuthor === author && String(textNode?.textContent || '').trim() === previousText && textNode) textNode.textContent = nextText;
      });
    }

    function openCommentEditor(comment, row) {
      editingComment = { ...comment, row };
      commentEditStatus.textContent = '';
      commentEditField.value = comment.text;
      commentEditor.showModal();
      requestAnimationFrame(() => {
        commentEditField.focus();
        commentEditField.setSelectionRange(commentEditField.value.length, commentEditField.value.length);
      });
    }

    async function refreshCommentCatalog() {
      if (!apiBase || !commentsDialog?.open || !modalArticle) return;
      try {
        const payload = await api('/posts');
        const post = (payload.posts || []).find(item => String(item.id) === String(modalArticle.dataset.postId));
        commentCatalog = new Map((post?.comments || []).map(comment => [String(comment.id), comment]));
        decorateOwnComments();
      } catch (_) {}
    }

    function decorateOwnComments() {
      if (!commentsDialog?.open || !modalArticle || !commentCatalog.size) return;
      const used = new Set();
      commentsDialog.querySelectorAll('.kkc-dialog-comment').forEach(row => {
        const rowData = commentRowData(row);
        const match = [...commentCatalog.values()].find(comment => {
          if (used.has(String(comment.id)) || normalizeAuthor(comment.author) !== rowData.author) return false;
          const override = commentOverrides.get(String(comment.id));
          return rowData.text === comment.text || rowData.text === override?.previous || rowData.text === override?.text;
        });
        if (!match) return;
        used.add(String(match.id));
        const override = commentOverrides.get(String(match.id));
        if (override && rowData.text !== override.text && rowData.textNode) rowData.textNode.textContent = ` ${override.text}`;
        if (!match.viewerOwn || row.querySelector('[data-edit-comment]')) return;
        const actions = row.querySelector('.kkc-dialog-comment__actions');
        if (!actions) return;
        const edit = document.createElement('button');
        edit.type = 'button';
        edit.dataset.editComment = String(match.id);
        edit.textContent = 'Bearbeiten';
        edit.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          openCommentEditor({ ...match, text: commentOverrides.get(String(match.id))?.text || match.text }, row);
        });
        actions.prepend(edit);
      });
    }

    function scheduleCommentRefresh() {
      if (!commentsDialog?.open) return;
      const nextSignature = [...commentsDialog.querySelectorAll('.kkc-dialog-comment')]
        .map(row => { const item = commentRowData(row); return `${item.author}:${item.text}`; })
        .join('|');
      if (nextSignature === commentSignature) return;
      commentSignature = nextSignature;
      clearTimeout(commentRefreshTimer);
      commentRefreshTimer = setTimeout(refreshCommentCatalog, 120);
    }

    editForm.addEventListener('submit', async event => {
      event.preventDefault();
      if (!editingArticle) return;
      const hashtags = [...tagsHolder.querySelectorAll('input:checked')].map(input => input.value);
      const room = roomSelect.value;
      const caption = captionField.value.trim();
      const altText = [room, caption].filter(Boolean).join(' – ').slice(0, 300);
      if (!caption || !hashtags.length) {
        status.textContent = 'Bitte ergänze deine Farbgeschichte und mindestens einen Hashtag.';
        return;
      }
      if (hashtags.length > 5) {
        status.textContent = 'Du kannst bis zu 5 Hashtags auswählen.';
        return;
      }
      const submit = editForm.querySelector('[type="submit"]');
      submit.disabled = true;
      submit.textContent = 'Speichert …';
      try {
        const id = editingArticle.dataset.postId;
        await api(`/posts/${encodeURIComponent(id)}/update`, { method: 'POST', body: JSON.stringify({ room, caption, altText, hashtags }) });
        const locationNode = editingArticle.querySelector('[data-template-location]');
        if (locationNode) {
          const suffix = locationNode.textContent.split('·').slice(1).join('·').trim() || 'Gerade eben';
          locationNode.textContent = `${room} · ${suffix}`;
        }
        const captionNode = editingArticle.querySelector('[data-template-caption]');
        if (captionNode) captionNode.textContent = caption;
        editingArticle.querySelectorAll('.kkc-post__media img').forEach(image => { image.alt = altText || `${room} – ${caption}`.slice(0, 300); });
        editingArticle.dataset.categories = hashtags.join(' ');
        const tags = editingArticle.querySelector('.kkc-post__tags');
        if (tags) tags.replaceChildren(...hashtags.map(value => {
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.category = value;
          button.textContent = `#${TAGS.find(tag => tag[0] === value)?.[1] || value}`;
          return button;
        }));
        editor.close();
      } catch (error) {
        status.textContent = error.message;
      } finally {
        submit.disabled = false;
        submit.textContent = 'Änderungen speichern';
      }
    });

    tagsHolder.addEventListener('change', event => {
      const checked = tagsHolder.querySelectorAll('input:checked');
      if (checked.length > 5) event.target.checked = false;
    });
    editor.querySelector('.kkc-edit-close').addEventListener('click', () => editor.close());
    editor.querySelector('[data-edit-cancel]').addEventListener('click', () => editor.close());
    editor.addEventListener('click', event => { if (event.target === editor) editor.close(); });

    commentEditForm.addEventListener('submit', async event => {
      event.preventDefault();
      if (!editingComment || !modalArticle) return;
      const nextText = commentEditField.value.trim();
      if (nextText.length < 8) {
        commentEditStatus.textContent = 'Ein hilfreicher Kommentar braucht mindestens 8 Zeichen.';
        return;
      }
      const submit = commentEditForm.querySelector('[type="submit"]');
      submit.disabled = true;
      submit.textContent = 'Speichert …';
      try {
        const postId = modalArticle.dataset.postId;
        const commentId = String(editingComment.id);
        const previousText = editingComment.text;
        const result = await api(`/posts/${encodeURIComponent(postId)}/comments/${encodeURIComponent(commentId)}`, {
          method: 'POST',
          body: JSON.stringify({ text: nextText })
        });
        const updated = { ...editingComment, ...(result.comment || {}), text: nextText, viewerOwn: true };
        commentCatalog.set(commentId, updated);
        commentOverrides.set(commentId, { previous: previousText, text: nextText });
        replaceCommentEverywhere(updated, previousText, nextText);
        editingComment = null;
        commentEditor.close();
      } catch (error) {
        commentEditStatus.textContent = error.message;
      } finally {
        submit.disabled = false;
        submit.textContent = 'Änderungen speichern';
      }
    });
    commentEditor.querySelectorAll('[data-comment-edit-close]').forEach(button => button.addEventListener('click', () => commentEditor.close()));
    commentEditor.addEventListener('click', event => { if (event.target === commentEditor) commentEditor.close(); });
    commentEditor.addEventListener('close', () => { editingComment = null; });

    function syncModal(article) {
      if (!article || !commentsDialog?.open) return;
      syncModalHashtags(article);
      const source = article.querySelector('.kkc-post__media');
      const stage = commentsDialog.querySelector('.kkc-comments-dialog__media');
      if (!source || !stage) return;
      stage.querySelector('[data-modal-media]')?.remove();
      const fallback = stage.querySelector('[data-comments-image]');
      if (fallback) fallback.hidden = true;
      const clone = source.cloneNode(true);
      clone.dataset.modalMedia = '';
      clone.querySelectorAll('.kkc-own-post-delete,.kkc-own-post-edit,.kkc-post__heart-burst,.kkc-post__color').forEach(node => node.remove());
      stage.append(clone);
      clone.querySelectorAll('.kkc-media-arrow').forEach(arrow => {
        const previous = arrow.classList.contains('kkc-media-arrow--prev') || arrow.dataset.mediaDirection === 'prev';
        arrow.dataset.cleanArrow = 'true';
        arrow.replaceChildren();
        arrow.insertAdjacentHTML('afterbegin', previous
          ? '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m12.5 4.5-5.5 5.5 5.5 5.5"/></svg>'
          : '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m7.5 4.5 5.5 5.5-5.5 5.5"/></svg>');
      });
      if (clone.querySelector('.kkc-compare-toggle')) {
        ensureComparisonDots(clone);
        showGalleryComparison(clone, 1);
      }
      syncModalHashtags(article);
    }

    function normalizeAuthor(value) {
      return String(value || '').trim().replace(/^@/, '').toLowerCase();
    }

    function profileArticles() {
      const author = normalizeAuthor(profileDialog?.querySelector('[data-dialog-profile-name]')?.textContent);
      if (!author || !feed) return [];
      return [...feed.querySelectorAll('.kkc-post')].filter(article => normalizeAuthor(article.dataset.author) === author);
    }

    function profilePreviewSource(article) {
      const media = article.querySelector('.kkc-post__media');
      if (!media) return null;
      const slides = [...media.querySelectorAll('.kkc-media-slide')];
      const preferred = media.querySelector('.kkc-compare-toggle')
        ? media.querySelector('.kkc-media-slide[data-media-index="1"]') || slides[1] || slides[0]
        : slides[0];
      if (preferred?.matches?.('img')) return preferred;
      return preferred?.querySelector?.('img') || media.querySelector('img');
    }

    function openProfilePost(article) {
      returnToProfileAfterComments = true;
      setTimeout(() => {
        const opener = article.querySelector('[data-focus-comment]');
        opener ? opener.click() : article.click();
      }, 0);
    }

    function enhanceOpenProfile() {
      if (!profileDialog?.open) return;
      const articles = profileArticles();
      const header = profileDialog.querySelector('.kkc-profile-dialog__head');
      const postsHolder = profileDialog.querySelector('[data-dialog-profile-posts]');
      if (!header || !postsHolder) return;

      const likeCount = articles.reduce((sum, article) => sum + Number(article.querySelector('[data-like-count]')?.textContent || 0), 0);
      const friendKeys = new Set(
        [...root.querySelectorAll('[data-follow][aria-pressed="true"]')]
          .map(button => normalizeAuthor(button.dataset.follow))
          .filter(Boolean)
      );
      let stats = profileDialog.querySelector('.kkc-profile-dialog__stats');
      if (!stats) {
        stats = document.createElement('div');
        stats.className = 'kkc-profile-dialog__stats';
        header.insertAdjacentElement('afterend', stats);
      }
      stats.innerHTML = `
        <span><strong>${articles.length}</strong>${articles.length === 1 ? 'Beitrag' : 'Beiträge'}</span>
        <span><strong>${likeCount}</strong>Gefällt mir</span>
        <span><strong>${friendKeys.size}</strong>Farbfreunde</span>`;

      let heading = profileDialog.querySelector('.kkc-profile-dialog__posts-title');
      if (!heading) {
        heading = document.createElement('h3');
        heading.className = 'kkc-profile-dialog__posts-title';
        heading.textContent = 'Beiträge';
        postsHolder.insertAdjacentElement('beforebegin', heading);
      }
      heading.hidden = !articles.length;

      postsHolder.replaceChildren(...articles.map(article => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kkc-profile-post';
        const source = profilePreviewSource(article);
        if (source) {
          const image = document.createElement('img');
          image.src = source.currentSrc || source.src;
          image.alt = source.alt || 'Community-Beitrag öffnen';
          button.append(image);
        }
        const caption = document.createElement('span');
        caption.textContent = article.querySelector('[data-template-caption]')?.textContent.trim() || 'Beitrag ansehen';
        button.append(caption);
        const mediaCount = article.querySelectorAll('.kkc-media-slide').length;
        if (mediaCount > 1) {
          const badge = document.createElement('small');
          badge.textContent = article.querySelector('.kkc-compare-toggle') ? 'Vorher · Nachher' : `${mediaCount} Medien`;
          button.append(badge);
        }
        button.addEventListener('click', () => openProfilePost(article));
        return button;
      }));
    }

    root.querySelectorAll('[data-account-view]').forEach(button => button.addEventListener('click', () => currentMode(button.dataset.accountView)));
    root.querySelectorAll('[data-view],[data-scroll-community]').forEach(button => button.addEventListener('click', () => currentMode('')));
    decorate();
    if (feed) new MutationObserver(decorate).observe(feed, { childList: true, subtree: true });
    if (commentsDialog) {
      new MutationObserver(() => {
        if (commentsDialog.open && modalArticle) requestAnimationFrame(() => {
          syncModalHashtags(modalArticle);
          scheduleCommentRefresh();
        });
      }).observe(commentsDialog, { childList: true, subtree: true });
      commentsDialog.addEventListener('close', () => {
        commentSignature = '';
        commentCatalog = new Map();
        if (commentEditor.open) commentEditor.close();
        if (returnToProfileAfterComments) {
          returnToProfileAfterComments = false;
          setTimeout(() => {
            if (!profileDialog?.open) profileDialog?.showModal();
            requestAnimationFrame(enhanceOpenProfile);
          }, 40);
        }
      });
    }
    if (profileDialog) {
      new MutationObserver(() => {
        if (profileDialog.open) requestAnimationFrame(enhanceOpenProfile);
      }).observe(profileDialog, { attributes: true, attributeFilter: ['open'] });
      profileDialog.addEventListener('click', event => {
        if (event.target.matches('[data-profile-lock-overlay]') || event.target.closest('[data-close-profile-lock]')) {
          event.preventDefault();
          profileDialog.close();
        }
      });
    }
    root.addEventListener('click', event => {
      if (event.target.closest('[data-profile-open]')) returnToProfileAfterComments = false;
      if (event.target.closest('[data-media-direction],[data-media-go],.kkc-own-post-edit')) return;
      let article = event.target.closest('.kkc-post');
      const activity = event.target.closest('[data-activity-post]');
      if (!article && activity) article = feed?.querySelector(`[data-post-id="${CSS.escape(activity.dataset.activityPost)}"]`);
      if (!article && event.target.closest('[data-open-comments-from-activity]')) article = feed?.querySelector('.kkc-post');
      if (article) {
        modalArticle = article;
        commentSignature = '';
        setTimeout(() => {
          syncModal(article);
          refreshCommentCatalog();
        });
      }
    });
  }

  function start() {
    document.querySelectorAll('[id^="kk-community-"]').forEach(init);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
